import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { PayShell } from "@/components/pay-shell";
import { authClient, isCustomerUser } from "@/lib/auth-client";

// صفحه‌های پرداخت (درگاه آزمایشی و بازگشت از درگاه): فقط برای مشتری واردشده، بیرون از قاب پنل
export const Route = createFileRoute("/pay")({
  ssr: false,
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession().catch(() => null);
    if (!session?.data || !isCustomerUser(session.data.user)) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
  },
  head: () => ({
    meta: [{ title: "پرداخت | تابان خودرو" }, { name: "robots", content: "noindex" }],
  }),
  component: PayLayout,
});

function PayLayout() {
  return (
    <PayShell panelLink>
      <Outlet />
    </PayShell>
  );
}
